module.exports = __webpack_public_path__ + "img/tech-17.d1bc9566.jpg";